import { TextMin } from '@/components/ProductPrice/ProductPrice.styled'
import { stringFormat } from '@/helpers/stringFormat'
import { useTranslations } from '@/hooks/useTranslations'

import type React from 'react'
import type { SxProps } from '@mui/material'

interface ProductMinSaveLabelsProps {
  minSaveLabel: string
  minimumQuantity: number
  percentage?: number
  sx?: SxProps
}

export const ProductMinSaveLabels: React.FC<ProductMinSaveLabelsProps> = ({
  minSaveLabel,
  minimumQuantity,
  percentage = null,
  sx,
}) => {
  const { translate } = useTranslations()

  return (
    <TextMin
      sx={{
        ...sx,
      }}
      variant="body1"
    >
      {percentage
        ? stringFormat(
            translate('product.discountLabel.minPercentSave')?.toString() ?? '',
            minimumQuantity?.toString(),
            minSaveLabel
          )
        : stringFormat(
            translate('product.discountLabel.minSumSave')?.toString() ?? '',
            minimumQuantity?.toString(),
            minSaveLabel
          )}
    </TextMin>
  )
}
